import { Tooltip, Checkbox, Box, Typography, Chip } from "@mui/material";
import { ChargingSiteActionMenu } from "./ChargingSiteActionMenu";
import { Icon } from "@iconify/react";
import mapFill from "@iconify/icons-eva/map-fill";
import settingsFill from "@iconify/icons-eva/settings-fill";
import batteryFill from "@iconify/icons-eva/battery-fill";
import homeFill from "@iconify/icons-eva/home-fill";
import editFill from "@iconify/icons-eva/edit-fill";

export const chargingSiteColumn = ({
  createZoneBtn,
  setCreateZoneBtn,
  handleAction,
  isReadOnly = false,
}) => [
  {
    field: "Actions",
    headerName: "",
    width: 50,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: ({ id, row }) => {
      return (
        <ChargingSiteActionMenu
          id={id}
          rowData={row}
          setCreateZoneBtn={setCreateZoneBtn}
          handleAction={handleAction}
        />
      );
    },
  },
  {
    field: "zone_name",
    headerName: "Site Name",
    flex: 2,
    minWidth: 200,
    renderCell: ({ value }) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 1.5,
            bgcolor: 'primary.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Icon icon={homeFill} width={20} height={20} color="white" />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.primary' }}>
            {value}
          </Typography>
        </Box>
        {!isReadOnly && (
          <Box
            sx={{
              opacity: 0.6,
              transition: 'opacity 0.2s ease',
              '&:hover': {
                opacity: 1,
              },
            }}
          >
            <Icon icon={editFill} width={16} height={16} color="text.secondary" />
          </Box>
        )}
      </Box>
    ),
  },
  {
    field: "load_balancing_value",
    headerName: "Load Value",
    flex: 1,
    minWidth: 120,
    renderCell: ({ value, row }) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
          {value}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {row.load_balancing_unit || 'kW'}
        </Typography>
      </Box>
    ),
  },
  {
    field: "isLoadBalancingReq",
    headerName: "Load Balancing",
    flex: 1,
    minWidth: 150,
    renderCell: ({ value }) => (
      <Chip
        label={value === 1 ? 'Enabled' : 'Disabled'}
        size="small"
        color={value === 1 ? 'success' : 'default'}
        variant="filled"
        icon={<Icon icon={settingsFill} width={14} height={14} />}
        sx={{
          fontWeight: 600,
          '& .MuiChip-label': {
            fontSize: '0.75rem',
          },
        }}
      />
    ),
  },
  {
    field: "chargers",
    headerName: "Chargers",
    flex: 1,
    minWidth: 120,
    renderCell: ({ value }) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Icon icon={batteryFill} width={16} height={16} color="#666" />
        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
          {value?.length || 0}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          chargers
        </Typography>
      </Box>
    ),
  },
];

export const availableChargerColumn = ({
  handleSelectionChange,
  tableData,
}) => [
  {
    field: "checkbox",
    headerName: "Checkbox",
    renderCell: (params) => (
      <Checkbox
        checked={params.row.selected} // Check if the row is selected
        onChange={(event) => {
          const updatedRows = [params.row];
          const rowIndex = updatedRows.findIndex(
            (row) => row.id === params.row.id
          ); // Find the index of the row
          updatedRows[rowIndex].selected = event.target.checked; // Update the selected property
          const result = tableData.map((data) => ({
            ...data,
            selected: data.chargerId === params.row.id ? true : data.selected,
          }));
          handleSelectionChange(result); // Call the callback to update the selected rows
        }}
      />
    ),
    sortable: false,
    width: 100,
  },
  {
    field: "chargerId",
    headerName: "Charger Id",
    flex: 0.5,
    renderCell: ({ value }) => (
      <Tooltip title={value} placement="top">
        <span>{value}</span>
      </Tooltip>
    ),
  },
];


